<template>
    <div id="shop-search-results" :class="isFavoritesPage ? 'pt-8' : ''">
        <SearchFavorites
            v-if="isFavoritesPage && fetchAvailableFavList && fetchAvailableFavList.length > 0"
            @startLoading="skeleton = true"
            @searchFavorites="searchFavorites"
        />

        <v-alert
            v-if="
                isFavoritesPage &&
                alert &&
                (!fetchAvailableFavList || fetchAvailableFavList.length === 0)
            "
            dense
            outlined
            type="info"
            ><TranslatableStringComponent :tstring="{ string: 'noFavorites' }"
        /></v-alert>
        <div v-if="(isFavoritesPage || isQuickOrderPage) && skeleton">
            <div v-for="i in 3" :key="i" class="mb-6">
                <v-skeleton-loader
                    type="list-item-avatar-three-line"
                    class="mx-auto"
                    elevation="2"
                ></v-skeleton-loader>
            </div>
        </div>

        <div
            class="row shop-results-container d-flex justify-center"
            v-if="!productList && !loadingData && !isFavoritesPage"
        >
            <TranslatableBlockComponent
                :tstring="{ string: 'unableToDisplayItems' }"
            />
        </div>
        <div class="d-flex justify-end mb-5">
            <v-switch
                label="price low-high"
                v-model="sort"
                dense
                @change="dataSort"
                hide-details=""
                v-if="productList && productList.length !== 0"
            ></v-switch>
        </div>

        <div
            v-show="isFavoritesPage ? !skeleton : true"
            class="row shop-results-container justify-center"
        >
            <v-col
                v-for="(item, i) in fetchProductList"
                :key="`${item.pn}${i}`"
                cols="12"
                sm="12"
                md="12"
                lg="12"
                class="shop-results"
            >
                <CardSingleSKUMobile
                    v-if="$vuetify.breakpoint.smAndDown"
                    :item="item"
                    :shop="true"
                    img-crop="fill"
                />
                <CardSingleSKU
                    v-else
                    :item="item"
                    :shop="true"
                    img-crop="fill"
                />
            </v-col>
            <div
                v-if="
                    favListComplete &&
                    fetchAvailableFavList &&
                    fetchAvailableFavList.length > 0
                "
                class="mt-3"
            >
                <span
                    ><TranslatableStringComponent
                        :tstring="{ string: 'endOfList' }"
                /></span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import CardSingleSKU from '~/components/cards/CardSingleSKU.vue'
import CardSingleSKUMobile from '~/components/cards/CardSingleSKUMobile.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import TranslatableBlockComponent from '~/components/TranslatableBlockComponent.vue'
import SearchFavorites from '~/components/SearchFavorites.vue'
// import handleAuth from '~/mixins/handleAuth'
import mobileFlexOrder from '~/mixins/mobileFlexOrder'
import fetchSchedulePrice from '~/util/fetchSchedulePriceNew'
import fetchSalePrice from '~/util/fetchSalePrice'

export default {
    name: 'ElasticProductResults',
    components: {
        CardSingleSKU,
        CardSingleSKUMobile,
        SearchFavorites,
        TranslatableStringComponent,
        TranslatableBlockComponent,
    },
    mixins: [mobileFlexOrder],
    props: {
        filters: {
            type: Object,
            default: null,
        },
        facets: {
            type: Array,
            default: null,
        },
        productList: {
            type: Array,
            default: null,
        },
        loadingData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            catalog: {
                products: {},
            },
            favoriteProductList: [],
            skeleton: true,
            alert: false,
            sort: false,
            page: 1,
            favListComplete: false,
        }
    },
    computed: {
        ...mapState(['auth']),
        ...mapState('priceList', ['priceList']),
        ...mapState('common', ['siteSettings']),
        ...mapGetters({
            fetchCartProducts: 'cart/fetchCartProducts',
            webUser: 'auth/webUser',
            fetchFavList: 'favorites/fetchFavList',
            fetchAvailableFavList: 'favorites/fetchAvailableFavList',
        }),
        fetchProductList() {
            if (this.isFavoritesPage || this.isQuickOrderPage) {
                return this.fetchFavList?.length > 0
                    ? this.removeDuplicates(
                          this.applyPriceList(this.updatedFavorites),
                          'pn'
                      )
                    : []
            } else {
                return !this.productList
                    ? []
                    : this.removeDuplicates(
                          this.applyPriceList(this.productList),
                          'pn'
                      )
            }
        },
        isFavoritesPage() {
            if (
                this.$route.params.slug ===
                this.getSlug({ slugName: 'favorites' })
            ) {
                return true
            } else {
                return false
            }
        },
        isQuickOrderPage() {
            if (
                this.$route.params.slug ===
                this.getSlug({ slugName: 'quick-order-pad' })
            ) {
                return true
            } else {
                return false
            }
        },
        updatedFavorites() {
            return this.favoriteProductList.filter((item) =>
                this.fetchFavList.some((f) => f.name === item.pn)
            )
        },
        isLoggedIn() {
            return this.auth.loggedIn
        },
    },
    mounted() {
        if (this.fetchFavList) this.getFavorites()
        else {
            setTimeout(() => {
                this.alert = true
                this.skeleton = false
            }, 3000)
        }
    },
    watch: {
        fetchFavList: {
            handler(newVal) {
                if (newVal) {
                    this.getFavorites()
                }
            },
            deep: true,
        },
    },
    methods: {
        async getFavorites() {
            if (this.isFavoritesPage || this.isQuickOrderPage) {
                if (this.fetchFavList?.length === 0){
                    this.$store.commit('favorites/setAvailableFavList', [])
                    this.alert = true
                } else if (this.fetchFavList?.length > 0) {
                    const favorites = this.fetchFavList.map((item) => item.name)
                    await this.fetchFavoriteProducts(favorites)
                } 
                this.favListComplete = true
                this.skeleton = false
            }
        },
        removeDuplicates(myArr, prop) {
            // TODO: Replace this with lodash
            // SOURCE: https://ilikekillnerds.com/2016/05/removing-duplicate-objects-array-property-name-javascript/
            return myArr.filter((obj, pos, arr) => {
                return (
                    arr
                        .map((mapObj) => obj.pn && mapObj[prop])
                        .indexOf(obj[prop]) === pos
                )
            })
        },
        async fetchFavoriteProducts(favourites) {
            const res = await this.$axios.post('elastic-search', {
                elasticQuery: {
                    size: 999,
                    query: {
                        terms: {
                            pn: favourites,
                        },
                    },
                },
                elasticIndex: 'products-sanity',
            })
            this.favoriteProductList = res.data.hits.hits
                .map((item) => ({
                    ...item._source,
                    isAvailable: true,
                    pkgqty: item._source.pkgqty || 1,
                }))
                .filter((obj, pos, arr) => {
                    // removing duplicate products with same 'pn' number
                    return (
                        arr
                            .map((mapObj) => obj.pn && mapObj.pn)
                            .indexOf(obj.pn) === pos
                    )
                })
            this.$store.commit(
                'favorites/setAvailableFavList',
                this.favoriteProductList
            )
        },
        applyPriceList(productList) {
            return productList.map((item, i) => {
                let salePrice
                if (this.priceList.length > 0) {
                    const selectedSchedulePrice = fetchSchedulePrice(
                        this.priceList,
                        item
                    )
                    salePrice =
                        selectedSchedulePrice &&
                        fetchSalePrice(selectedSchedulePrice, item.list_price)
                }
                const isFoundInCart = this.fetchCartProducts.find(
                    (cartItem) => cartItem.product_id === item.product_id
                )
                // console.log('------ isFoundInCart -----', isFoundInCart)
                let quantityInCart = 0
                let subTotalSalePrice = salePrice
                let subTotalListPrice = item.list_price
                if (isFoundInCart) {
                    quantityInCart = isFoundInCart.prod_quantity
                    subTotalSalePrice = salePrice * quantityInCart
                    subTotalListPrice = item.list_price * quantityInCart
                }
                return {
                    ...item,
                    sale_price: salePrice,
                    quantityInCart,
                    subTotalSalePrice,
                    subTotalListPrice,
                }
            })
        },
        dataSort() {
            this.fetchProductList.sort((a, b) => {
                let fa = a.subTotalSalePrice,
                    fb = b.subTotalSalePrice

                if (fa < fb) {
                    return this.sort ? -1 : 1
                }
                if (fa > fb) {
                    return this.sort ? 1 : -1
                }
                return 0
            })
        },
        searchFavorites(favList) {
            this.skeleton = false
            this.favoriteProductList = favList
        },
    },
}
</script>
